export default __webpack_public_path__ + "static/image 2-16397ec171ceeb25de3a276d805c6455.png";